exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._2JQkmHv4e1BVEOER_XylmU{padding:1px 0 0}", ""]);

// exports
exports.locals = {
	"todos": "_2JQkmHv4e1BVEOER_XylmU"
};